/*
 * @Description: 账户管家互转单
 * @Author: 杨志航
 * @Date: 2026-05-25 15:26:28
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
  DatePicker,
  message,
} from 'antd'
import { allTrim, filterParams, cryptoParamsIntoUrl, getExport } from '@/utils'
import { Link } from 'react-router-dom'
import Import from '@/components/Import'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'
const projectList = ['360', '头条']
const isSuccessList = [
  { id: 0, name: '导入中' },
  { id: 1, name: '导入成功' },
  { id: 2, name: '导入失败' },
]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const TransferOrder = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [visibleFile, setVisibleFile] = useState(false)
  const [importType, setImportType] = useState(1)
  const ImportRef = useRef(null)

  useEffect(() => {
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getTransferOrderList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.transferTime && vals.transferTime.length === 2) {
          vals.sTime = vals.transferTime[0].format(dateFormat)
          vals.eTime = vals.transferTime[1].format(dateFormat)
        }
        delete vals.transferTime
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    setSpinLoading(true)
    getExport('/fortune/AccountManageTransfer/export', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  //导入
  const onImportFile = type => {
    setImportType(type)
    setVisibleFile(true)
    ImportRef.current.onRemoved()
  }

  const doImport = (fileList) => {
    if (fileList.length > 0) {
      if (fileList[0].status !== "removed") {
        const { name, full, url } = fileList[0]
        api.importTransferOrder({
          name,
          full,
          relative: url,
          type: importType
        }).then(() => {
          message.success('导入成功')
          ImportRef.current.onLoading()
          onReset()
          setVisibleFile(false)
        }).catch(() => {
          ImportRef.current.onLoading()
        })
      } else {
        message.error('请导入模板')
      }
    } else {
      message.error('请导入模板')
    }
  }

  return <>
    <Spin spinning={spinLoading}>
      <div className="search-doc-wrap">
        <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
          <div className="form-box">
            <FormItem label="转出公司名称">
              {getFieldDecorator('outCompanyName')(<Input placeholder="请输入转出公司名称" />)}
            </FormItem>
            <FormItem label="转出端口名称">
              {getFieldDecorator('outPortName')(<Input placeholder="请输入转出端口名称" />)}
            </FormItem>
            <FormItem label="转出厂商ID">
              {getFieldDecorator('outFirmId')(<Input placeholder="请输入转出厂商ID" />)}
            </FormItem>
            <FormItem label="项目">
              {getFieldDecorator('project')(<Select
                placeholder="请选择"
                allowClear
              >
                {
                  projectList.map((item, index) => <Option key={index} value={item}>{item}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="转入公司名称">
              {getFieldDecorator('inCompanyName')(<Input placeholder="请输入转入公司名称" />)}
            </FormItem>
            <FormItem label="转入端口名称">
              {getFieldDecorator('inPortName')(<Input placeholder="请输入转入端口名称" />)}
            </FormItem>
            <FormItem label="转入厂商ID">
              {getFieldDecorator('inFirmId')(<Input placeholder="请输入转入厂商ID" />)}
            </FormItem>
            <FormItem label="操作人">
              {getFieldDecorator('operator')(<Input placeholder="请输入操作人" />)}
            </FormItem>
            <FormItem label="退单订单编号">
              {getFieldDecorator('refundOrderNo')(<Input placeholder="请输入退单订单编号" />)}
            </FormItem>
            <FormItem label="提单订单编号">
              {getFieldDecorator('submitOrderNo')(<Input placeholder="请输入提单订单编号" />)}
            </FormItem>
            <FormItem label="导入结果">
              {getFieldDecorator('isSuccess')(<Select
                placeholder="请选择"
                allowClear
              >
                {
                  isSuccessList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="转账日期">
              {getFieldDecorator('transferTime')(<RangePicker
                placeholder={['开始日期', '结束日期']}
              />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Button type="primary" onClick={() => onImportFile(1)}>360项目账户管家互转导入</Button>
          <Button type="primary" onClick={() => onImportFile(2)} style={{ marginLeft: 15 }}>头条项目账户管家互转导入</Button>
          <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>数据导出</Button>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          scroll={{ x: 'max-content' }}
        >
          <Column 
            title="序号" 
            dataIndex="id"
            render={(text, record, index) => count - ((currentPage - 1) * pageSize + index)} 
          />
          <Column title="项目" dataIndex="project" />
          <Column title="转出公司名称" dataIndex="outCompanyName" />
          <Column title="转出端口名称" dataIndex="outPortName" />
          <Column title="转出端口识别号" dataIndex="outPortId" />
          <Column title="转出厂商ID" dataIndex="outFirmId" />     
          <Column title="转入公司名称" dataIndex="inCompanyName" />
          <Column title="转入端口名称" dataIndex="inPortName" />
          <Column title="转入端口识别号" dataIndex="inPortId" />
          <Column title="转入厂商ID" dataIndex="inFirmId" />
          <Column title="转账时间" dataIndex="transferTime" />     
          <Column title="互转金额" dataIndex="transferAmount" />
          <Column 
            title="退单订单编号" 
            dataIndex="refundOrderNo" 
            render={(text, record) => (
              <>
                {text && JSON.parse(text).map((item, index) => (
                  <div key={index}>
                    {item.is_qcdd ? item.number : (
                      <Link 
                        to={cryptoParamsIntoUrl(`/${item.type === 0 ? 'orderDirect' : 'orderAgent'}/refundDetail`, { id: item.ids, batchIds: item.ids })} 
                        target="_blank"
                      >
                        {item.number}
                      </Link>
                    )}
                  </div>
                ))}
              </>
            )}
          />
          <Column 
            title="提单订单编号" 
            dataIndex="submitOrderNo" 
            render={(text, record) => (
              <>
                {text && JSON.parse(text).map((item, index) => (
                  <div key={index}>
                    {item.is_qcdd ? item.number : (
                      <Link 
                        to={cryptoParamsIntoUrl(item.type === 0 ? '/orderDirect/directDetail' : '/orderAgent/agentDetail', { id: item.id })} 
                        target="_blank"
                      >
                        {item.number}
                      </Link>
                    )}
                  </div>
                ))}
              </>
            )}
          />
          <Column 
            title="导入结果" 
            dataIndex="isSuccessCn" 
            render={(text, record) => text === '导入失败' ? <span style={{ color: 'red' }}>{text}</span> : <span>{text}</span>}
          />
          <Column title="失败原因" dataIndex="failReason" />
          <Column title="操作人" dataIndex="operator" />
          <Column title="导入时间" dataIndex="importTime" />
        </Table>
      </div>
    </Spin>
    <Import
      onSearch={doImport}
      visibleFile={visibleFile}
      onCloseImport={() => setVisibleFile(false)}
      ImportTemplate={`/api/File/DownTemplate?url=/templates/${importType === 1 ? 'account_manage_transfer.xlsx&name=360项目账户管家互转导入模板' : 'transfer_record.xlsx&name=头条项目账户管家互转导入模板'}`}
      ImportRef={ImportRef}
    />
  </>
}

export default Form.create()(TransferOrder)
